export enum RedirectInvitation {
  REGISTRATION = 'REGISTRATION',
  TEAM = 'TEAM',
  LOGIN = 'LOGIN'
}
